import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import HomeLayout from "../layouts/HomeLayout";
import AboutLayout from "../layouts/AboutLayout";
import ProjectLayout from "../layouts/ProjectLayout";
import Contact from "../components/Contact/Contact";
import AdminLayout from "../layouts/AdminLayout";
import AdminHome from "../components/Admin/AdminHome";
import AdminAbout from "../components/Admin/AdminAbout";
import AdminProjects from "../components/Admin/AdminProjects";
import AdminContact from "../components/Admin/AdminContact";
import AdminProfile from "../components/Admin/AdminProfile";
import AdminFooter from "../components/Admin/AdminFooter";
import NotFound from "../components/Error/NotFound";
import Login from "../components/Login/Login";
import Loader from "../components/Loader/Loader";
import PrivateRoute from "./PrivateRoute";
import TermsConditions from "../pages/TermsConditions";
import OurStory from "../pages/OurStory";
import Benefit from "../pages/Benefit";
import Carrier from "../pages/Carrier";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ProjectDetails from "../components/Projects/ProjectDetails";


const MainRouter = createBrowserRouter([
    {
        path: "/",
        element: <MainLayout></MainLayout>,
        children: [
            {
                path: '/',
                element: <HomeLayout></HomeLayout>
            },
            {
                path: '/home',
                element: <HomeLayout></HomeLayout>
            },
            {
                path: '/about-us',
                element: <AboutLayout></AboutLayout>
            },
            {
                path: '/projects',
                element: <ProjectLayout></ProjectLayout>
            },
            {
                path: '/project/:id',
                element: <ProjectDetails></ProjectDetails>,
                loader: async ({ params }) => {
                    return fetch(`https://projitize.vercel.app/project/${params.id}`)
                }
            },
            {
                path: 'contact-us',
                element: <Contact></Contact>
            }
        ]
    },
    {
        path: '/admin',
        element: <PrivateRoute><AdminLayout></AdminLayout></PrivateRoute>,
        children: [
            {
                path: '/admin',
                element: <AdminHome></AdminHome>
            },
            {
                path: '/admin/home',
                element: <AdminHome></AdminHome>
            },
            {
                path: '/admin/about',
                element: <AdminAbout></AdminAbout>
            },
            {
                path: '/admin/projects',
                element: <AdminProjects></AdminProjects>
            },
            {
                path: '/admin/contact',
                element: <AdminContact></AdminContact>
            },
            {
                path: '/admin/profile',
                element: <AdminProfile></AdminProfile>
            },
            {
                path: '/admin/footer',
                element: <AdminFooter></AdminFooter>
            },
        ]
    },
    {
        path: '/login',
        element: <Login></Login>
    },
    {
        path: '/loader',
        element: <Loader></Loader>
    },
    {
        path: '/our-story',
        element: <OurStory></OurStory>
    },
    {
        path: '/benefits',
        element: <Benefit></Benefit>
    },
    {
        path: '/carrier',
        element: <Carrier></Carrier>
    },
    {
        path: '/terms-and-conditions',
        element: <TermsConditions></TermsConditions>
    },
    {
        path: '/privacy-policy',
        element: <PrivacyPolicy></PrivacyPolicy>
    },
    {
        path: '*',
        element: <NotFound></NotFound>
    },
]);

export default MainRouter;